import type { RootState } from '@ui/app/store';

export const selectDataCuration = (state: RootState) => state.dataCuration;
export const selectDocumentFilters = (state: RootState) => state.dataCuration.documentFilters;
